import * as React from 'react';
import moment from 'moment';
import injectSheet from 'react-jss';
import BellIcon from 'src/components/common/icons/BellIcon';
import { ShipmentExecutionActivityType } from '../../SE.Types';
import { StylesProps } from 'src/Library/Types';
import styles from '../SEChatActivity.styles';

interface SEActivityTimelineProps extends StylesProps<ReturnType<typeof styles>> {
  data: ShipmentExecutionActivityType[];
}

const SEShipmentActivityTimeline: React.FC<SEActivityTimelineProps> = ({ data, classes }) => {
  if (!data || !data.length) {
    return (
      <div className={classes.emptyPageParentDiv}>
        <BellIcon/>
        <div className={classes.emptyPageContentDiv}>
          No activity to show.<br/>
          Try adjusting the filters.
        </div>
      </div>
    );
  }

  const makecontent = (content) => {
    if (!content) return;
    const str = <>{
      content.map((node, index) => {
        const { value, details } = node;
        const subStr = details && details.bold ?
          <span style={{ fontWeight: 600 }}>{value}</span> :
          value;
        return details?.url ?
          <a key={index} href={details.url}>{subStr}</a> :
          subStr;
      })
    }</>;
    return str;
  }

  return <>
    {data.map((activity, ind) => (
      <div
        className={classes.cardParentDiv}
        style={{
          borderLeft: (ind === data.length - 1)
            ? '3px solid transparent'
            : '3px solid #EDEDED',
        }}
      >
        <div>
          <div className={classes.blueCircle}></div>
          <div className={classes.activityNameDiv}>{activity.name}
            <div className={classes.activityMetaContentDiv}>
              {activity.meta && (<> | {makecontent(activity.meta.content)}</>)}
            </div>
          </div>
        </div>
        <div className={classes.activityBlock}>
          <div className={classes.activityBlockHeader}>
            <div>
              <div className={classes.activityCreatorNameDiv}>{activity.creator.name}</div>
              <div className={classes.activityOrgNameDiv}>{activity.organisationName}</div>
            </div>
            <div className={classes.activityCreatedAtDiv}>{moment(activity.createdAt).format('DD MMM YYYY | hh:mm a')}</div>
          </div>
          <div className={classes.activityContentDiv}>{makecontent(activity.content)}</div>
        </div>
      </div>
    ))}
  </>;
}

export default injectSheet(styles)(SEShipmentActivityTimeline);
